import { cn } from "@omni/utils/styles";

export const StoreCardSkeleton = () => {
    return (
        <li
            className={cn(
                "tw:p-2 tw:flex tw:flex-col tw:relative tw:overflow-hidden tw:min-h-33.75 tw:bg-grey tw:border-0"
            )}
        />
    );
};
